
import Vue from 'vue';
import HomePageCommentsSection from '../components/home-page/HomePageCommentsSection.vue';
import HomePageDescriptionSection from '../components/home-page/HomePageDescriptionSection.vue';
import HomePageHeaderSection from '../components/home-page/HomePageHeaderSection.vue';
import HomePageLowerCardsSection from '../components/home-page/HomePageLowerCardsSection.vue';
import HomePageNumbersSection from '../components/home-page/HomePageNumbersSection.vue';
import HomePageTryForFreeSection from '../components/home-page/HomePageTryForFreeSection.vue';
import HomePageUpperCardsSection from '../components/home-page/HomePageUpperCardsSection.vue';
import HomePageFooter from '../components/HomePageFooter.vue';
export default Vue.extend({
  components: {
    HomePageHeaderSection,
    HomePageDescriptionSection,
    HomePageUpperCardsSection,
    HomePageNumbersSection,
    HomePageLowerCardsSection,
    HomePageCommentsSection,
    HomePageTryForFreeSection,
    HomePageFooter
  },
  name: 'Home'
});
